import styled from "styled-components";

export const StyledCoverImagesItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1.6rem;
`;
export const StyledCoverImagesItemImageWrapper = styled.div`
  width: 10.2rem;
  height: 5rem;
`;
